// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__aAhJi","cell":"ColumnAccessor_cell__3fxF5","firstCellAccent":"ColumnAccessor_firstCellAccent__1I-YX"};